const login = {
  brand_product: '达人建联',
  brand_tagline: '专业的 TikTok 达人建联与营销管理平台',
  hero_welcome: '欢迎来到 Wowbit.creator',
  hero_desc: '手机号或邮箱登录。官方店铺授权（东南亚）· 私信 / 平台邮箱 / 定向邀约。',
  plan_pro: '专业版',
  hero_feature:
    '海量 TikTok 达人资源，精准筛选目标达人，支持批量私信邀约、邮件邀约、商品定向推荐，一站式打通达人发现、精准触达与合作管理全流程，',
  hero_feature_highlight: '让达人建联更精准，营销合作更高效。',

  title: '欢迎来到 Wowbit.creator',
  subtitle: '登录后即可开始达人建联',
  register_title: '注册 Wowbit.creator',
  register_subtitle: '填写信息完成注册，即可开始达人建联',
  wechat_login: '微信登录',
  wechat_qr_title: '微信登录',
  wechat_scan: '请使用微信扫码登录',
  wechat_qr_failed: '二维码生成失败',
  wechat_expired: '二维码已过期，请重新生成',
  wechat_refresh: '重新生成',
  wechat_expires_in: '{{time}} 后过期',
  or: '或',
  login_method: '登录方式',
  code_login: '验证码登录',
  password_login: '密码登录',

  account_label: '手机号/邮箱',
  account_placeholder: '请输入手机号或邮箱',
  account_required: '请输入手机号或邮箱',
  account_invalid: '请输入正确的手机号或邮箱',
  username_label: '用户名',
  username_placeholder: '请输入用户名',
  username_required: '请输入用户名',
  username_max: '用户名最长 12 个字符',
  display_name_max: '用户名称最多 12 个字符',
  code_label: '验证码',
  code_placeholder: '6 位验证码',
  code_required: '请输入验证码',
  code_len: '验证码为 6 位',
  code_digits: '验证码为 6 位数字',
  send_code: '获取验证码',
  password_label: '密码',
  password_placeholder: '请输入密码',
  password_required: '请输入密码',
  password_min: '密码至少 6 位',
  password_rule: '密码至少 8 个字符，最多 24 个字符',
  login_password_rule: '密码不超过 72 个字符，且 UTF-8 不超过 72 字节',

  login_btn: '登录',
  register_btn: '注册',
  forgot_password: '忘记密码？',
  go_register: '立即注册',
  go_login: '已有账号，去登录',

  reset_password_title: '重置密码',
  new_password_label: '新密码',
  new_password_required: '请输入新密码',
  confirm_password_label: '确认新密码',
  confirm_password_required: '请再次输入新密码',
  password_mismatch: '两次输入的密码不一致',
  reset_password_rule: '密码至少 12 个字符，不能包含空格，且 UTF-8 不超过 72 字节',
  reset_password_btn: '重置密码',
  reset_password_success: '密码重置成功，请使用新密码登录',
  reset_password_failed: '重置失败',
  reset_password_failed_retry: '重置失败，请稍后重试',

  code_sent: '验证码已发送',
  send_failed: '发送失败',
  send_failed_retry: '发送失败，请稍后重试',
  login_success: '登录成功',
  login_failed: '登录失败',
  login_failed_retry: '登录失败，请稍后重试',
  register_success: '注册成功，请登录',
  register_failed: '注册失败',
  register_failed_retry: '注册失败，请稍后重试'
};

export default login;
